import React from "react";
import { Card, Row } from "antd";

interface SkinProfileComponentInterface {
  data?: any;
}

const SkinProfileComponent: React.FC<SkinProfileComponentInterface> = (
  props
) => {
  const { data } = props;

  const naText = () => {
    return <i>N/A</i>;
  };

  return (
    <Row>
      <Card bordered={false} className="skin-profile__card">
        <h2 className="section-title">Your Skin Profile</h2>
        <div className="skinProfile-table">
          <div className="skinProfile-table-item">
            <h3 className="ms-card-title">Profile Fill Dates</h3>
            <span className="skinProfile-table-item-description ms-title-des">
              {data?.profile_fill_date ?? naText()}
            </span>
          </div>
          {/* <div className="skinProfile-table-item">
            <h3 className="ms-card-title">Skincare Steps</h3>
            <span className="skinProfile-table-item-description ms-title-des">
              {data?.skin_care_steps ?? naText()}
            </span>
          </div> */}
          <div className="skinProfile-table-item">
            <h3 className="ms-card-title">Skincare Level</h3>
            <span className="skinProfile-table-item-description ms-title-des">
              {data?.skincare_level ?? naText()}
            </span>
          </div>
          <div className="skinProfile-table-item">
            <h3 className="ms-card-title">Skin Type</h3>
            <span className="skinProfile-table-item-description ms-title-des">
              {data?.skin_type ?? naText()}
            </span>
          </div>
          {/* <div className="skinProfile-table-item">
            <h3 className="ms-card-title">Product Budget</h3>
            <span className="skinProfile-table-item-description ms-title-des">{data?.product_budget ?? naText()}</span>
          </div> */}
          <div className="skinProfile-table-item">
            <h3 className="ms-card-title">Acne</h3>
            <span className="skinProfile-table-item-description ms-title-des">
              {data?.acne ?? naText()}
            </span>
          </div>
          <div className="skinProfile-table-item">
            <h3 className="ms-card-title">Skin Concerns</h3>
            <span className="skinProfile-table-item-description ms-title-des">
              {data?.skin_goal ?? naText()}
            </span>
          </div>
          <div className="skinProfile-table-item">
            <h3 className="ms-card-title">Sensitivity</h3>
            <span className="skinProfile-table-item-description ms-title-des">
              {data?.sensitivity ?? naText()}
            </span>
          </div>
        </div>
      </Card>
    </Row>
  );
};

export default SkinProfileComponent;
